module.exports = __webpack_public_path__ + "img/logo_osmosis.50f055b7.png";